import Vue from 'vue'
import Router from 'vue-router'
import VueHead from 'vue-head'
import Home from '@/components/Home.vue'
import Work from '@/components/Work.vue'

Vue.use(Router)
Vue.use(VueHead)

export default new Router({
  mode: 'history',
  routes: [
    {
      path: '/',
      name: 'Home',
      component: Home
    },
    {
      path: '/work/:name/',
      name: 'Work',
      component: Work
    },
  ],
})



// WEBPACK FOOTER //
// ./src/router.js